/**
 * フッターエリア
 */
import { ChangeDetectionStrategy, Component, ChangeDetectorRef } from '@angular/core';
import { SupportComponent } from '../../../components/support-class';
import { CommonLibService, HeaderService, LoadScriptService } from '../../../services';
import { distinctUntilKeyChanged } from 'rxjs';
import { AswContextType, MOffice } from '../../../interfaces';
import { environment } from '@env/environment';

/**
 * フッターエリア
 */
@Component({
  selector: 'asw-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['footer.scss'],
})
export class FooterComponent extends SupportComponent {
  constructor(
    protected _common: CommonLibService,
    public _headerService: HeaderService,
    private _changeDetector: ChangeDetectorRef,
    private _loadScriptSvc: LoadScriptService
  ) {
    super(_common);
  }

  /** 企業情報リンク表示有無 */
  public isDisplayImprintLink = false;

  /** クッキー詳細設定リンク表示有無 */
  public isDisplayCookieSettingsLink = false;

  /** CPRA（個人情報保護法）リンク表示有無 */
  public isDisplayCaliforniaPrivacyRightsAcLink = false;

  /** 外部送信規律リンク表示有無 */
  public isDisplayExternalTransmissionOfUserInfoLink = false;

  init() {
    this._getCacheMaster((data) => {
      this._addContextSubscription(data);
    });
  }

  /**
   * Office_All のキャッシュされたマスターデータを取得
   * @param callback - 読み込まれたマスターデータを受け取るコールバック関数
   */
  private _getCacheMaster(callback: (master: MOffice[]) => void): void {
    this.subscribeService(
      'getAllOffice',
      this._common.aswMasterService.load([{ key: 'Office_All', fileName: 'Office_All' }], true),
      ([value]) => {
        this.deleteSubscription('getAllOffice');
        callback(value);
      }
    );
  }

  /**
   * リンク表示非表示判定
   * @param officeAll 全オフィスリスト
   */
  private _addContextSubscription(officeAll: MOffice[]) {
    this.subscribeService(
      'footerAswContext',
      this._common.aswContextStoreService
        .getAswContext$()
        .pipe(distinctUntilKeyChanged(AswContextType.POINT_OF_SALE_ID)),
      (data) => {
        const pointOfSaleId = data.pointOfSaleId;
        const currentOffice = officeAll.find((office) => office.office_code === pointOfSaleId);
        // 企業情報リンク表示非表示判定
        this.isDisplayImprintLink = currentOffice?.pos_country_code === 'DE';
        // クッキー詳細設定リンク表示非表示設定
        this.isDisplayCookieSettingsLink = !!currentOffice?.available_ensighten_tag;
        // CPRA（個人情報保護法）表示非表示設定
        this.isDisplayCaliforniaPrivacyRightsAcLink = currentOffice?.pos_country_code === 'US';
        // 外部送信規律リンク表示非表示設定
        this.isDisplayExternalTransmissionOfUserInfoLink = currentOffice?.pos_country_code === 'JP';
        this._changeDetector.markForCheck();
      }
    );
  }

  /**
   * モーダルの表示
   */
  public openModal() {
    this._loadScriptSvc.load$(environment.ensighten.url).subscribe((url) => {
      if (url && (window as any).Bootstrapper) {
        (window as any).Bootstrapper.gateway.openModal();
      }
    });
  }

  destroy() {}
  reload() {}

  /**
   * 上へ戻るボタン押下
   */
  onClickPageTop() {
    window.scrollTo(0, 0);
  }

  /**
   * ANAロゴ押下イベント
   */
  onClickAnaLogo(event: Event) {
    event.preventDefault();
    window.location.href = this._headerService.getTopUrl();
  }
}
